import React from 'react';
import { useTranslation } from "react-i18next";

const SubscriptionBanner = () => {
    const [t] = useTranslation("common");

    return (
        <div style={{
            backgroundColor: '#f4de57',
            color: '#343a40',
            textAlign: 'center',
            padding: '10px',
            width: '100%',
            zIndex: 9999,
            position: 'sticky',
            top: 0
        }}>
            <span dangerouslySetInnerHTML={{ __html: t("Subscription_Banner_Message") }} />
        </div>
    );
};

export default SubscriptionBanner;
